import { z } from "zod";

export const state = z.enum([
  "START",
  "ORDER_SUMMARY",
  "ORDER_FULFILLMENT",
  "ORDER_PENDING_CANCELLATION",
  "ORDER_COMMITTED",
  "COMPLETED",
]);

export const changeMsisdnOrchestrator = z.object({
  type: z.literal("NJU_CHANGE_MSISDN"),
  state,
  id: z.string(),
  verifiedMsisdn: z.string().optional(),
  deleteAfterDate: z.string().optional(),
});

export type IChangeMsisdnOrchestrator = z.infer<
  typeof changeMsisdnOrchestrator
>;
